import dynamicRewardsPageContent from './dynamicRewardsPageContent';

export default dynamicRewardsPageContent;
